import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { KitDetailPage } from './kit-detail.page';

const routes: Routes = [
  {
    path: '',
    component: KitDetailPage
  }
]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class KitDetailPageRoutingModule {}
